import VideoModal from "components/Modals/VideoModal"
import { useState } from "react"
import Button from "react-bootstrap/esm/Button"

export default function VideoModalButton({ videoTitle, videoUrl } : { videoTitle: string, videoUrl: string }) {
    const [show, setShow] = useState(false)

    const handleShow = () => setShow(true)
    const handleClose = () => setShow(false)
    return (
        <>
            <Button onClick={handleShow}>{videoTitle}</Button>
            <VideoModal videoTitle={videoTitle} videoUrl={videoUrl} show={show} handleClose={handleClose} />
        </>
    )
}
